import { Item, UpdateItemRequest, UpdateItemResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type { Item };
export const updateItem = makeCloudFunction<
  UpdateItemRequest,
  UpdateItemResponse
>("item", "updateItem");
